import { render, staticRenderFns } from "./DelaySmsDialog.vue?vue&type=template&id=38a3df08&scoped=true"
import script from "./DelaySmsDialog.vue?vue&type=script&lang=js"
export * from "./DelaySmsDialog.vue?vue&type=script&lang=js"
import style0 from "./DelaySmsDialog.vue?vue&type=style&index=0&id=38a3df08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3df08",
  null
  
)

export default component.exports